/** @format */

import React, { useState } from "react"
import {
	Container,
	IconBoostListe,
	IconBoostAlert,
	TextWrapper,
	Text,
	ConsumptionValue,
	Info,
	IconContainer,
	ActionButton,
	ActionText
} from "./ConsumptionSummary.styled"

import { ProductTypeRequest } from "_clients/BFFClient"
import {
	ConsumptionSummaryProps,
	ProductTypeKeysMapper,
} from "./ConsumptionSummary.types"
import { useRelativeRouter } from '../../../shared/hooks/useRelativeRouter';
import { BuyMorePopin } from "../BuyMorePopin/BuyMorePopin"
import RemiseStockPopin from "../RemiseStockPopin/RemiseStockPopin"

const ConsumptionSummary = (props: ConsumptionSummaryProps) => {
	const { consumptionInfo, showDispatchButton = true, dispatchUrl, isLoading, searchParams } = props
	const [isPopinBuyMoreOpen, setIsPopinBuyMoreOpen] = useState<boolean>()
	const [isRemiseStockPopinOpen, setIsRemiseStockPopinOpen] = useState<boolean>()

	const productType = props.productType[0]
	const router = useRelativeRouter();
	function GetIcon() {
		switch (productType) {
			case ProductTypeRequest.BoostAlert.toString(): {
				return <IconBoostAlert data-testid="iconBoostAlert-test-id" />
			}
			default: {
				return <IconBoostListe data-testid="iconBoostListe-test-id" />
			}
		}
	}

	return (
		<Container>
			<IconContainer isLoading={isLoading}>
				<GetIcon />
			</IconContainer>
			<div className="stats">
				<Info isLoading={isLoading}>
					<ConsumptionValue data-testid="not-used-value-test-id">
						{consumptionInfo?.notUsed ?? ""}
					</ConsumptionValue>
					<TextWrapper data-testid="textWrapper-test-id">
						{ProductTypeKeysMapper[productType] ?? ""} non utilisés
					</TextWrapper>
				</Info>
				<Text isLoading={isLoading}>Le total de vos boosts non-utilisés par votre réseau</Text>
				<ActionText onClick={() => setIsRemiseStockPopinOpen(true)} isLoading={isLoading} data-testid="action-text-remise-stock" >
					Rappeler les boosts non utilisés
				</ActionText>
			</div>
			<div className="divider" />
			<div className="stats">
				<Info isLoading={isLoading}>
					<ConsumptionValue data-testid="consumption-value-test-id">
						{consumptionInfo?.consumption ?? ""}%
					</ConsumptionValue>
					<TextWrapper>de boosts déjà utilisés</TextWrapper>
				</Info>
				<Text isLoading={isLoading}>
					Sur un total de
					<span className="text-wrapper" data-testid="total-value-test-id">
						{` ${consumptionInfo?.total ?? ""} `}
					</span>
					boosts achetés
				</Text>
			</div>
			{showDispatchButton && (
				<ActionButton
					isLoading={isLoading}
					disabled={isLoading}
					size="medium"
					testID="btn-distribute-test-id"
					kind="primary"
					variant="normal"
					tag="button"
					onClick={() => {
						router.push(dispatchUrl)
					}}
					onPointerEnterCapture={undefined}
					onPointerLeaveCapture={undefined}
				>
					Répartir mes boosts
				</ActionButton>
			)}
			{!showDispatchButton && (
				<ActionButton
					isLoading={isLoading}
					disabled={isLoading}
					tertiaryButtonBorder={!isLoading}
					size="medium"
					testID="btn-distribute-test-id"
					kind="tertiary"
					variant="normal"
					tag="button"
					onClick={() => {
						setIsPopinBuyMoreOpen(true)
					}}
					onPointerEnterCapture={undefined}
					onPointerLeaveCapture={undefined}
				>
					Acheter plus de boosts
				</ActionButton>
			)}

			<BuyMorePopin
				open={isPopinBuyMoreOpen}
				onClosePopin={value => setIsPopinBuyMoreOpen(value)}
				buyMoreBoostsDistribution={props.buyMoreBoostsDistribution}
			></BuyMorePopin>

			<RemiseStockPopin
				searchParams={searchParams}
				open={isRemiseStockPopinOpen}
				onClosePopin={() => setIsRemiseStockPopinOpen(false)}
				newAvailableStock={consumptionInfo?.notUsed}
			/>
		</Container>
	)
}

export default ConsumptionSummary
